const ampRoutes = [
  (route) => route.startsWith('/story/'),
  (route) => route === `/[livdemyId]/[bcType]/[url]/[version]/preview`,
]

const isAmpRoute = (route) => ampRoutes.some((test) => test(route))

export default isAmpRoute
